<!-- Footer -->
<footer class="content-footer footer bg-footer-theme">
  <div class="container-xxl">
    <div class="footer-container d-flex align-items-center justify-content-between py-2 flex-md-row flex-column ">
      <div>
        ©
        {{currentYear}} , Made with ❤️ by <a href="https://sadinhub.com" target="_blank" class="fw-semibold">SADIN</a>,
        In 🕌 Medina, Saudi Arabia
      </div>
      <div class="footer-support-actions">
        <a
          class="footer-support-action"
          pTooltip="FAQ"
          tooltipPosition="top"
          aria-label="FAQ">
          <i class="fa-duotone fa-book-open-reader"></i>
        </a>
        <a
          class="footer-support-action"
          pTooltip="AI Live Support"
          tooltipPosition="top"
          aria-label="AI Live Support">
          <i class="fa-duotone fa-headset"></i>
        </a>
        <a
          class="footer-support-action"
          pTooltip="Documentation"
          tooltipPosition="top"
          aria-label="Documentation">
          <i class="fa-duotone fa-book"></i>
        </a>
      </div>
    </div>
  </div>
</footer>
<!-- / Footer -->
